const lang = {
  remind_token_expire: {
    content: '残り{minutes}分で強制的にログアウトします。ログイン状態を延長する場合は延長ボタンを押してください。',
    btn_cancel: '延長しない',
    btn_submit: '延長する',
  },
  confirm_delete: {
    content: '削除する場合「削除する」をクリックして下さい。',
    btn_cancel: 'キャンセル',
    btn_submit: '削除する',
  },
}

export default lang
